<template>
  <div class="main-container">
    <HeaderSoftware />

    <!-- ===== PASSWORD GATE ===== -->
    <transition name="diag-fade">
      <div v-if="!authenticated" class="diag-gate">
        <div class="diag-gate__box">
          <h2 class="diag-gate__title">Autenticación</h2>
          <p class="diag-gate__sub">Acceso restringido. Ingresa la contraseña para continuar.</p>
          <form class="diag-gate__form" @submit.prevent="checkPassword">
            <input
              v-model="gatePassword"
              type="password"
              class="diag-gate__input"
              :class="{ 'diag-gate__input--error': gateError }"
              placeholder="Contraseña"
              autocomplete="current-password"
              ref="gateInput"
            />
            <p v-if="gateError" class="diag-gate__error">Contraseña incorrecta. Intenta de nuevo.</p>
            <button type="submit" class="diag-btn diag-btn--accent" style="width:100%;margin-top:0">Acceder →</button>
          </form>
        </div>
      </div>
    </transition>

    <div v-if="authenticated" class="diagnostico-wrap">

      <!-- ===== HERO ===== -->
      <section class="diag-hero" id="diagnostico-inicio">
        <div class="diag-hero__bg"></div>
        <div class="diag-hero__grid"></div>
        <div class="container">
          <div class="diag-hero__inner">

            <div class="diag-hero__content">
              <span class="diag-tag">Diagnóstico Gratuito · Sector Cooperativo LATAM</span>
              <h1>¿Qué tan preparada está tu <em>caja o cooperativa</em> para los próximos 5 años?</h1>
              <p class="diag-hero__sub">
                El sector financiero cooperativo enfrenta 7 amenazas estructurales que ya están generando cierres e intervenciones regulatorias. En 14 preguntas identifica tu nivel de madurez en cada dimensión y recibe una hoja de ruta concreta.
              </p>
              <div class="diag-hero__btns">
                <button class="diag-btn-hero diag-btn-hero--gold" @click="openModal">Iniciar diagnóstico →</button>
                <a href="#por-que" class="diag-btn-hero diag-btn-hero--outline" @click.prevent="scrollTo('#por-que')">Ver contexto del sector</a>
              </div>
              <div class="diag-hero__stats">
                <div class="diag-stat"><span class="diag-stat__n">14</span><span class="diag-stat__l">preguntas clave</span></div>
                <div class="diag-stat"><span class="diag-stat__n">7</span><span class="diag-stat__l">dimensiones</span></div>
                <div class="diag-stat"><span class="diag-stat__n">~8 min</span><span class="diag-stat__l">sin compromiso</span></div>
              </div>
            </div>

            <div class="diag-hero__visual">
              <div class="diag-preview-card">
                <div class="dpc-header">
                  <div class="dpc-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#94692a" stroke-width="1.5" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <div class="dpc-title">Diagnóstico de Madurez Institucional</div>
                    <div class="dpc-sub">Sector Cooperativo · Sendoagil</div>
                  </div>
                </div>
                <div v-for="(dim, i) in DIMENSIONS" :key="i" class="dpc-dim">
                  <div class="dpc-dim-row">
                    <span>{{ dim.s }}</span>
                    <span :style="{ color: previewScores[i] <= 30 ? '#b03030' : '#94692a' }">{{ previewScores[i] }}/100</span>
                  </div>
                  <div class="dpc-bar">
                    <div :style="{ width: previewScores[i] + '%', background: previewScores[i] <= 30 ? '#b03030' : 'linear-gradient(90deg,#94692a,#9f855a)' }"></div>
                  </div>
                </div>
                <div class="dpc-footer">
                  <span class="dpc-score">38<small>/100</small></span>
                  <span class="dpc-level" style="background:#faf0dc;color:#b07020">En Proceso</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <!-- ===== CONTEXTO ===== -->
      <section class="diag-context" id="por-que">
        <div class="container">
          <div class="diag-context__grid">
            <div class="diag-context__text">
              <span class="diag-tag">El sector cooperativo hoy</span>
              <h2 class="diag-section-h">No son presiones cíclicas.<br>Son <em>fracturas sistémicas.</em></h2>
              <p>El número de cooperativas a nivel mundial cayó un <strong>10% en un solo año</strong> (WOCCU 2024). Ecuador pasó de más de 1,100 a ~290. Coopeservidores — entre las 4 más grandes de Costa Rica — fue declarada inviable en 2024. Ninguna de sus instancias de gobernanza había cumplido sus funciones.</p>
              <p style="margin-top:.8rem">Las instituciones que sobrevivan esta ola de reestructuración no serán las más grandes — serán las que actúen primero.</p>
              <button class="diag-btn-hero diag-btn-hero--gold" style="display:inline-flex;margin-top:1.5rem" @click="openModal">Evaluar mi institución →</button>
            </div>
            <div class="diag-context__stats">
              <div v-for="stat in CONTEXT_STATS" :key="stat.n" class="diag-cstat">
                <div class="diag-cstat__n" :style="{ color: stat.alert ? '#b03030' : '#94692a' }">{{ stat.n }}</div>
                <div class="diag-cstat__l">{{ stat.l }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>

    <template v-if="authenticated">

    <FooterMain />

    <div class="whatsapp-container">
      <a href="https://api.whatsapp.com/send?phone=+524431371292&text=Hola,%20me%20gustar%C3%ADa%20cotizar%20un%20proyecto%20de%20software." target="_blank" aria-label="WhatsApp" rel="noopener noreferrer">
        <div class="whatsapp-btn">
          <img src="https://cdn-icons-png.flaticon.com/512/1384/1384023.png" alt="WhatsApp" loading="lazy" width="38" height="38"/>
        </div>
      </a>
    </div>

    <!-- ===== MODAL OVERLAY ===== -->
    <transition name="diag-fade">
      <div class="diag-overlay" v-if="showModal" @click.self="closeModal">
        <transition name="diag-modal-enter">
          <div class="diag-modal" v-if="showModal" role="dialog" aria-modal="true">

            <!-- ── Modal Header ── -->
            <div class="diag-mhd">
              <div class="diag-mhd__brand">
                <svg class="diag-mhd__icon" width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#94692a" stroke-width="1.5" stroke-linejoin="round"/>
                </svg>
                <div>
                  <div class="diag-mhd__name">Diagnóstico Institucional</div>
                  <div class="diag-mhd__sub">{{ modalSubtitle }}</div>
                </div>
              </div>

              <!-- Steps (solo durante preguntas) -->
              <div class="diag-mhd__steps" v-if="currentScreen === 'questions'">
                <template v-for="(dimIdx, si) in orderedDims">
                  <div
                    class="diag-step"
                    :key="'s' + si"
                    :class="{
                      'diag-step--done':   si < currentDimStep,
                      'diag-step--active': si === currentDimStep,
                    }"
                  >
                    <div class="diag-step__dot">
                      <svg v-if="si < currentDimStep" width="9" height="9" viewBox="0 0 10 10">
                        <polyline points="1.5,5 4,7.5 8.5,2" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/>
                      </svg>
                      <span v-else>{{ si + 1 }}</span>
                    </div>
                    <div class="diag-step__lbl">{{ DIMENSIONS[dimIdx].s }}</div>
                    <div v-if="selectedPains.includes(dimIdx)" class="diag-step__pain">★</div>
                  </div>
                  <div
                    v-if="si < 6"
                    class="diag-step-line"
                    :key="'l' + si"
                    :class="{ 'diag-step-line--done': si < currentDimStep }"
                  ></div>
                </template>
              </div>

              <button class="diag-mhd__close" @click="closeModal" aria-label="Cerrar diagnóstico">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
            </div>

            <!-- ── Modal Body ── -->
            <div class="diag-modal__body" ref="modalBody">

              <!-- Progress bar (preguntas) -->
              <div class="diag-prog" v-show="currentScreen === 'questions'">
                <div class="diag-prog__top">
                  <span class="diag-prog__label">
                    <strong>{{ DIMENSIONS[orderedDims[currentDimStep]].s }}</strong>
                    · Dimensión {{ currentDimStep + 1 }} de 7
                  </span>
                  <span class="diag-prog__num">{{ answeredCount }} / 14</span>
                </div>
                <div class="diag-prog__track">
                  <div class="diag-prog__fill" :style="{ width: (answeredCount / 14 * 100) + '%' }"></div>
                </div>
              </div>

              <!-- ── BIENVENIDA ── -->
              <div v-show="currentScreen === 'welcome'" class="diag-card">
                <h3>Diagnóstico de Madurez Institucional</h3>
                <p class="diag-card__sub">Diseñado exclusivamente para Cajas de Ahorro, Cooperativas de Ahorro y Crédito, SOCAPs y Credit Unions de América Latina. Evaluamos 7 dimensiones críticas con 2 preguntas clave cada una.</p>
                <div class="diag-welcome-model">
                  <div class="diag-level-row" v-for="(lv, i) in LEVELS" :key="i">
                    <span class="diag-level-dot" :style="{ background: LEVEL_COLORS[i] }"></span>
                    <span class="diag-level-name" :style="{ color: LEVEL_COLORS[i] }">{{ lv }}</span>
                    <span class="diag-level-range">{{ LEVEL_RANGES[i] }}</span>
                    <span class="diag-level-desc">{{ LEVEL_DESC[i] }}</span>
                  </div>
                </div>
                <button class="diag-btn diag-btn--accent" @click="go('institution')">Comenzar →</button>
                <p class="diag-hint">14 preguntas · ~8 minutos · 100% gratuito y confidencial</p>
              </div>

              <!-- ── INSTITUCIÓN ── -->
              <div v-show="currentScreen === 'institution'" class="diag-card">
                <h3>Tu institución</h3>
                <p class="diag-card__sub">Contextualiza el diagnóstico y selecciona los dolores que más impactan a tu institución hoy. Eso determina el orden en que evaluaremos cada dimensión.</p>

                <div class="diag-grid-2">
                  <div>
                    <label class="diag-label">Nombre de la institución</label>
                    <input class="diag-input" type="text" v-model="institutionName" placeholder="Ej. Caja Popular San Marcos">
                  </div>
                  <div>
                    <label class="diag-label">País</label>
                    <select class="diag-input" v-model="country">
                      <option v-for="c in countryOptions" :key="c">{{ c }}</option>
                    </select>
                  </div>
                </div>

                <label class="diag-label">Tamaño de la institución (colaboradores)</label>
                <div class="diag-pills">
                  <span v-for="opt in segmentOptions" :key="opt.value"
                    class="diag-pill" :class="{ 'diag-pill--on': segment === opt.value }"
                    @click="segment = opt.value">{{ opt.label }}</span>
                </div>

                <label class="diag-label" style="margin-top:.4rem">
                  ¿Cuáles de estos dolores identificas en tu institución hoy?
                  <span class="diag-label__hint">Selecciona todos los que apliquen</span>
                </label>
                <div class="diag-pain-grid">
                  <div
                    v-for="(pain, i) in PAIN_OPTIONS"
                    :key="i"
                    class="diag-pain-card"
                    :class="{ 'diag-pain-card--on': selectedPains.includes(i) }"
                    @click="togglePain(i)"
                  >
                    <svg class="diag-pain-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path :d="pain.icon" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>{{ pain.label }}</span>
                    <div class="diag-pain-check" v-show="selectedPains.includes(i)">
                      <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="1.5,5 4,7.5 8.5,2" fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/></svg>
                    </div>
                  </div>
                </div>

                <button class="diag-btn diag-btn--accent" @click="startQuestions">Iniciar diagnóstico →</button>
                <button class="diag-btn diag-btn--back" @click="go('welcome')">← Volver</button>
              </div>

              <!-- ── PREGUNTAS ── -->
              <div v-show="currentScreen === 'questions'" class="diag-card">
                <template v-if="activeDim !== null && currentQuestion !== null">

                  <transition :name="'q-slide-' + transitionDir" mode="out-in">
                    <div :key="questionKey" class="diag-question-wrap">

                      <!-- Título + descripción de la dimensión -->
                      <div class="diag-dim-header">
                        <h3 class="diag-dim-title">{{ activeDim.n }}</h3>
                        <p class="diag-dim-desc">{{ activeDim.context }}</p>
                      </div>

                      <div class="diag-q-divider"></div>

                      <!-- Pregunta -->
                      <div class="diag-qblock">
                        <div class="diag-qn">Pregunta {{ currentQuestionNumber }} de 14</div>
                        <div class="diag-qt">{{ currentQuestion.text }}</div>
                        <div class="diag-opts">
                          <button
                            v-for="(opt, v) in currentQuestion.options"
                            :key="v"
                            class="diag-opt"
                            :class="{ 'diag-opt--on': getAnswer(currentDimStep, currentQuestionInDim) === v, 'diag-opt--advancing': autoAdvancing && getAnswer(currentDimStep, currentQuestionInDim) === v }"
                            @click="setAnswer(currentDimStep, currentQuestionInDim, v)"
                          >
                            <div class="diag-odot"></div>
                            <div>
                              <span class="diag-opt-level">Nivel {{ v + 1 }}</span>
                              {{ opt }}
                            </div>
                          </button>
                        </div>
                      </div>

                    </div>
                  </transition>

                  <div class="diag-q-nav">
                    <button class="diag-btn diag-btn--back diag-btn--back-sm" @click="prevDim">← Anterior</button>
                    <button
                      class="diag-btn diag-btn--nav"
                      :class="allCurrentAnswered ? 'diag-btn--accent' : 'diag-btn--disabled'"
                      :disabled="!allCurrentAnswered"
                      @click="nextDim"
                    >Siguiente →</button>
                  </div>
                </template>
              </div>

              <!-- ── RESULTADOS: se abre en dashboard separado, este estado no se usa en el wizard ── -->

              <!-- ── LEAD ── -->
              <div v-show="currentScreen === 'lead'" class="diag-card">
                <div class="diag-lead-badge" :style="{ background: LEVEL_BG[level] }">
                  <div class="diag-lb-score" :style="{ color: LEVEL_COLORS[level] }">{{ overallScore }}</div>
                  <div>
                    <div class="diag-lb-level" :style="{ color: LEVEL_COLORS[level] }">{{ LEVELS[level] }}</div>
                    <div class="diag-lb-inst">{{ institutionName || 'Tu institución' }}</div>
                  </div>
                </div>
                <h3>Recibe tu reporte completo</h3>
                <p class="diag-card__sub">Un especialista Sendoagil revisará tu diagnóstico y te enviará un plan de transformación con estimados de inversión y ROI esperado, específico para el sector cooperativo.</p>
                <div class="diag-grid-2">
                  <div>
                    <label class="diag-label">Nombre completo</label>
                    <input class="diag-input" type="text" v-model="leadName" placeholder="Tu nombre">
                  </div>
                  <div>
                    <label class="diag-label">Cargo</label>
                    <input class="diag-input" type="text" v-model="leadRole" placeholder="Ej. Gerente General">
                  </div>
                </div>
                <label class="diag-label">Correo institucional</label>
                <input class="diag-input" type="email" v-model="leadEmail" placeholder="tu@caja.com.mx">
                <label class="diag-label">WhatsApp (opcional)</label>
                <input class="diag-input" type="tel" v-model="leadPhone" placeholder="+52 443 000 0000">
                <button class="diag-btn diag-btn--accent" @click="go('thanks')">Enviar y recibir reporte →</button>
                <button class="diag-btn diag-btn--back" @click="goBackToResults">← Volver a resultados</button>
                <p class="diag-hint">Información confidencial. Solo usada para enviarte el reporte.</p>
              </div>

              <!-- ── GRACIAS ── -->
              <div v-show="currentScreen === 'thanks'" class="diag-card diag-card--center">
                <div class="diag-thanks-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <polyline points="4,12 9,17 20,6" stroke="#2a7a4b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <h3>¡Diagnóstico enviado!</h3>
                <p class="diag-card__sub" style="max-width:420px;margin:0 auto 1.5rem">Un especialista Sendoagil te contactará en las próximas 24 horas hábiles con tu reporte personalizado.</p>
                <div class="diag-thanks-list">
                  <div class="diag-thanks-item" v-for="item in thanksItems" :key="item">
                    <div class="diag-check-dot"><svg width="9" height="9" viewBox="0 0 9 9"><polyline points="1.5,4.5 3.5,6.5 7.5,2.5" fill="none" stroke="#2a7a4b" stroke-width="1.5" stroke-linecap="round"/></svg></div>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <button class="diag-btn diag-btn--accent" style="max-width:280px;margin:1.5rem auto 0" @click="closeModal">Cerrar →</button>
              </div>

            </div><!-- /modal body -->
          </div><!-- /modal -->
        </transition>
      </div><!-- /overlay -->
    </transition>

    <!-- ===== DASHBOARD DE RESULTADOS (modal separado, casi pantalla completa) ===== -->
    <transition name="diag-fade">
      <div class="diag-overlay" v-if="showResultsDashboard" @click.self="closeResultsDashboard">
        <transition name="diag-modal-enter">
          <div class="diag-dash" v-if="showResultsDashboard" role="dialog" aria-modal="true">

            <!-- Header del dashboard -->
            <div class="diag-dash__hd">
              <div class="diag-dash__hd-brand">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#94692a" stroke-width="1.5" stroke-linejoin="round"/>
                </svg>
                <div>
                  <div class="diag-dash__inst">{{ institutionName || 'Tu institución' }}</div>
                  <div class="diag-dash__meta">{{ segmentLabel }} · {{ country }} · Sector Cooperativo LATAM</div>
                </div>
              </div>
              <button class="diag-mhd__close" @click="closeResultsDashboard" aria-label="Cerrar resultados">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
            </div>

            <!-- Cuerpo: score + radar + leyenda de dimensiones -->
            <div class="diag-dash__body">

              <!-- Col 1: score general -->
              <div class="diag-dash__score-panel">
                <div class="diag-dash__score-num" :style="{ color: LEVEL_COLORS[level] }">{{ overallScore }}</div>
                <div class="diag-dash__score-lbl">Índice de madurez<br>institucional</div>
                <div class="diag-dash__score-level" :style="{ color: LEVEL_COLORS[level] }">{{ LEVELS[level] }}</div>
                <div class="diag-dash__score-range" :style="{ background: LEVEL_BG[level], color: LEVEL_COLORS[level] }">{{ LEVEL_RANGES[level] }} pts</div>
                <p class="diag-dash__insight">{{ INSIGHTS[level] }}</p>
                <div v-if="unexpectedWeaknesses.length" class="diag-dash__alert">
                  <strong>⚠ Brecha no identificada:</strong>
                  {{ unexpectedWeaknesses.map(i => DIMENSIONS[i].n).join(' · ') }}.
                </div>
              </div>

              <!-- Col 2: Radar chart SVG -->
              <div class="diag-dash__radar-panel">
                <svg class="diag-radar" viewBox="-90 -90 480 480" xmlns="http://www.w3.org/2000/svg">

                  <!-- Polígonos de fondo (grid) -->
                  <polygon v-for="(pts, gi) in radarGeometry.gridPolygons" :key="'g'+gi"
                    :points="pts" fill="none" stroke="#e0ddd8" stroke-width="1"/>

                  <!-- Líneas de ejes -->
                  <line v-for="(ax, ai) in radarGeometry.axisLines" :key="'ax'+ai"
                    :x1="radarGeometry.cx" :y1="radarGeometry.cy" :x2="ax.x2" :y2="ax.y2"
                    stroke="#d8d5d0" stroke-width="1"/>

                  <!-- Etiquetas de escala -->
                  <text v-for="gl in radarGeometry.gridLabels" :key="'gl'+gl.text"
                    :x="gl.x" :y="gl.y - 3" font-size="7" fill="#bbb" text-anchor="middle">{{ gl.text }}</text>

                  <!-- Polígono benchmark -->
                  <polygon :points="radarGeometry.benchPolygon"
                    fill="rgba(180,160,120,0.07)" stroke="#c8b88a" stroke-width="1.5" stroke-dasharray="5,3"/>

                  <!-- Polígono de scores (relleno) -->
                  <polygon :points="radarGeometry.scorePolygon"
                    fill="rgba(148,105,42,0.14)" stroke="#94692a" stroke-width="2"/>

                  <!-- Puntos en cada vértice de score -->
                  <circle v-for="(p, pi) in radarGeometry.scorePoints" :key="'dot'+pi"
                    :cx="p.x" :cy="p.y" r="5" :fill="p.color" stroke="#fff" stroke-width="1.5"/>

                  <!-- Etiquetas de dimensión + score -->
                  <g v-for="(lp, li) in radarGeometry.labelPos" :key="'lbl'+li">
                    <text :x="lp.x" :y="+lp.y - 5" :text-anchor="lp.anchor"
                      font-size="9.5" font-weight="700" :fill="lp.color" dominant-baseline="middle">{{ lp.label }}</text>
                    <text :x="lp.x" :y="+lp.y + 8" :text-anchor="lp.anchor"
                      font-size="9" :fill="lp.color" dominant-baseline="middle" opacity="0.75">{{ lp.score }}/100</text>
                  </g>

                </svg>
                <div class="diag-radar-legend">
                  <span class="diag-radar-legend__item diag-radar-legend__item--score">Tu institución</span>
                  <span class="diag-radar-legend__item diag-radar-legend__item--bench">Promedio {{ segmentLabel }}</span>
                </div>
              </div>

              <!-- Col 3: leyenda compacta de dimensiones (2 columnas) -->
              <div class="diag-dash__dims">
                <div class="diag-dash__dims-hd">
                  <span class="diag-dash__dims-title">Detalle por dimensión</span>
                </div>
                <div class="diag-dims-grid">
                  <div class="diag-dim-card" v-for="d in sortedDimsByScore" :key="d.i">
                    <div class="diag-dim-card__top">
                      <span class="diag-dim-card__dot" :style="{ background: DIMENSIONS[d.i].c }"></span>
                      <span class="diag-dim-card__name">{{ DIMENSIONS[d.i].s }}</span>
                      <span v-if="selectedPains.includes(d.i)" class="diag-dash__pain-tag">★</span>
                      <span class="diag-dim-card__score" :style="{ color: d.s <= 30 ? '#b03030' : DIMENSIONS[d.i].c }">{{ d.s }}<small>/100</small></span>
                    </div>
                    <div class="diag-dim-card__bot">
                      <span class="diag-dim-card__vs" :style="{ color: d.s >= benchmarkData[d.i] ? '#2a7a4b' : '#b03030' }">{{ d.s >= benchmarkData[d.i] ? '+' : '' }}{{ d.s - benchmarkData[d.i] }} vs sect.</span>
                      <span class="diag-dim-card__mat" :style="{ color: scoreLevel(d.s).color }">{{ scoreLevel(d.s).short }}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <!-- Hoja de ruta: timeline Gantt -->
            <div class="diag-dash__roadmap">
              <div class="diag-dash__rm-hd">Hoja de ruta priorizada · Transformación cooperativa</div>
              <div class="diag-gantt">

                <!-- Regla de tiempo -->
                <div class="diag-gantt__ruler">
                  <div class="diag-gantt__tick" style="left:0%">Ahora</div>
                  <div class="diag-gantt__tick" style="left:33%">3 meses</div>
                  <div class="diag-gantt__tick" style="left:66%">6 meses</div>
                  <div class="diag-gantt__tick" style="left:100%">12 meses</div>
                  <div class="diag-gantt__grid-line" style="left:33%"></div>
                  <div class="diag-gantt__grid-line" style="left:66%"></div>
                </div>

                <!-- Filas de prioridad -->
                <div
                  v-for="(d, pi) in sortedDimsByScore.slice(0, 3)"
                  :key="'gnt' + d.i"
                  class="diag-gantt__row"
                >
                  <div class="diag-gantt__item" :style="{ marginLeft: (pi * 28) + '%', width: '44%' }">

                    <div class="diag-gantt__bar" :style="{ background: DIMENSIONS[d.i].c }">
                      <span class="diag-gantt__p-tag">P{{ pi + 1 }}</span>
                      <span class="diag-gantt__d-tag" :style="{ background: DIMENSIONS[d.i].bg, color: DIMENSIONS[d.i].tc }">{{ DIMENSIONS[d.i].s }}</span>
                      <span class="diag-gantt__bar-title">{{ ROADMAP[d.i].t }}</span>
                    </div>

                    <div class="diag-gantt__chips">
                      <span
                        v-for="chip in ROADMAP[d.i].chips.slice(0, 3)"
                        :key="chip"
                        class="diag-chip"
                        :style="{ borderColor: DIMENSIONS[d.i].c, color: DIMENSIONS[d.i].tc }"
                      >{{ chip }}</span>
                    </div>

                  </div>
                </div>

              </div>
            </div>

            <!-- Acciones -->
            <div class="diag-dash__actions">
              <button class="diag-btn diag-btn--accent" style="max-width:300px" @click="goToLead">Recibir reporte completo →</button>
              <p class="diag-dash__actions-hint">Reporte detallado + sesión de 30 min con especialista Sendoagil</p>
              <button class="diag-btn diag-btn--back" style="max-width:160px;margin-top:0" @click="closeResultsDashboard">Cerrar</button>
            </div>

          </div>
        </transition>
      </div>
    </transition>

    </template><!-- /authenticated -->

  </div>
</template>

<script>
import HeaderSoftware from '@/components/HeaderSoftware.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'DiagnosticoDigital',
  components: { HeaderSoftware, FooterMain },

  data() {
    return {
      // ── Auth gate ──────────────────────────────────────────────────────────
      authenticated: sessionStorage.getItem('diag_auth') === '1',
      gatePassword: '',
      gateError: false,

      // ── Modales ────────────────────────────────────────────────────────────
      showModal: false,
      showResultsDashboard: false,

      // ── Flujo ──────────────────────────────────────────────────────────
      currentScreen: 'welcome',      // 'welcome' | 'institution' | 'questions' | 'lead' | 'thanks'
      currentDimStep: 0,             // 0–6, índice dentro de orderedDims
      currentQuestionInDim: 0,       // 0 ó 1 — pregunta activa dentro de la dimensión
      transitionDir: 'next',         // 'next' | 'prev'
      autoAdvancing: false,          // true mientras cuenta regresiva antes de auto-avance

      // ── Datos institución ──────────────────────────────────────────────
      institutionName: '',
      segment: 'mediana',
      country: 'México',
      selectedPains: [],          // índices de dimensiones seleccionadas como dolores

      // ── Respuestas: answers[dimStep][localQ] = 0|1|2|3 ─────────────────
      answers: {},                // clave: `${dimStep}_${localIdx}` → valor 0-3

      // ── Lead ───────────────────────────────────────────────────────────
      leadName: '', leadRole: '', leadEmail: '', leadPhone: '',

      // ── Datos estáticos ────────────────────────────────────────────────
      previewScores: [35, 28, 42, 38, 22, 30, 32],

      CONTEXT_STATS: [
        { n: '−10%', l: 'Cooperativas de crédito mundiales en un año (WOCCU 2024)', alert: true },
        { n: '23.8%', l: 'Morosidad en cooperativas Nivel 2B de Perú (SBS 2024)', alert: true },
        { n: '60%', l: 'COOPACs peruanas sin sistema AML implementado', alert: true },
        { n: '0', l: 'Cooperativas LATAM clasificadas como "Nativa Digital" (BID Lab 2025)', alert: true },
        { n: '118M', l: 'Clientes que ya tiene Nubank en América Latina', alert: false },
        { n: '77%', l: 'Eficiencia promedio del sector cooperativo (estudios DEA)', alert: false },
      ],

      segmentOptions: [
        { value: 'pequena', label: 'Pequeña (menos de 50)' },
        { value: 'mediana', label: 'Mediana (50–200)' },
        { value: 'grande',  label: 'Grande (más de 200)' },
      ],

      countryOptions: ['México','Colombia','Ecuador','Perú','Costa Rica','El Salvador','Guatemala','Bolivia','Chile','Brasil','Otro'],

      PAIN_OPTIONS: [
        { label: 'Debilidad en la gobernanza directiva',    icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75' },
        { label: 'Rezago en transformación digital',        icon: 'M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z' },
        { label: 'Presión regulatoria (AML, NIIF 9)',       icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
        { label: 'Morosidad y calidad de cartera',          icon: 'M13 17h8m0 0V9m0 8l-8-8-4 4-6-6' },
        { label: 'Déficit de talento especializado',        icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
        { label: 'Pérdida de socios jóvenes ante fintechs', icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' },
        { label: 'Falta de plan estratégico ejecutable',    icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
      ],

      DIMENSIONS: [
        { n: 'Gobernanza Institucional',  s: 'Gobernanza',  c: '#94692a', bg: '#f5ede0', tc: '#6b4a1a',
          context: 'La calidad de la toma de decisiones estratégicas depende del perfil técnico del Consejo y de sus mecanismos de rendición de cuentas. Una gobernanza débil convierte los riesgos externos en crisis internas que el equipo operativo no puede contener.' },
        { n: 'Madurez Digital',           s: 'Digital',     c: '#185FA5', bg: '#e6f1fb', tc: '#042C53',
          context: 'La posición digital determina si una institución puede crecer sin incrementar costos proporcionales. La brecha entre lo que el socio puede hacer en línea y lo que espera poder hacer define si la cooperativa es relevante o prescindible para las nuevas generaciones.' },
        { n: 'Cumplimiento Regulatorio',  s: 'Regulatorio', c: '#1D9E75', bg: '#e8f5ee', tc: '#085041',
          context: 'El entorno regulatorio del sector cooperativo se endurece cada ciclo. Las instituciones que gestionan el cumplimiento como proceso proactivo acumulan ventaja; las que reaccionan solo cuando el regulador presiona acumulan riesgo invisible que puede materializarse en sanciones o intervención.' },
        { n: 'Calidad de Cartera',        s: 'Cartera',     c: '#b03030', bg: '#faeaea', tc: '#7a1515',
          context: 'La calidad de cartera refleja la solidez de los criterios de otorgamiento y la capacidad de anticipar el deterioro antes de que ocurra. No es solo un indicador financiero — es el termómetro de la madurez operativa y del rigor con que se gestiona el riesgo crediticio.' },
        { n: 'Talento y Capital Humano',  s: 'Talento',     c: '#993556', bg: '#fbeaf0', tc: '#4b1528',
          context: 'Las cooperativas compiten por el mismo talento especializado que bancos y fintechs, sin los mismos recursos. La brecha de capacidades en TI, riesgo y cumplimiento limita directamente la velocidad de transformación: ninguna iniciativa digital avanza más rápido que el equipo que la ejecuta.' },
        { n: 'Captación Generacional',    s: 'Socios',      c: '#D85A30', bg: '#faece7', tc: '#4a1b0c',
          context: 'La base de socios es el activo estratégico más importante de una cooperativa. La capacidad de atraer y retener a las generaciones jóvenes determina la sostenibilidad a largo plazo — y esa ventana se cierra cada año que la propuesta de valor digital no mejora.' },
        { n: 'Ejecución Estratégica',     s: 'Estrategia',  c: '#5945e6', bg: '#eeeeff', tc: '#2d2080',
          context: 'La ejecución estratégica diferencia a las instituciones que crecen deliberadamente de las que simplemente operan. Un plan sin KPIs medibles ni seguimiento formal es decorativo; el presupuesto que no está alineado a prioridades estratégicas es capital que se diluye sin impacto.' },
      ],

      DIM_QUESTIONS: [
        // Dim 0 – Gobernanza
        [
          { text: '¿Con qué perfil técnico cuentan los integrantes del Consejo de Administración?',
            options: ['Son socios voluntarios sin formación técnica en riesgo, finanzas ni tecnología',
                      'Algunos tienen experiencia financiera básica, pero no en riesgo ni tecnología',
                      'Al menos la mitad cuenta con perfil técnico en finanzas, riesgo o TI',
                      'El Consejo integra expertos por competencia en todas las áreas críticas del negocio'] },
          { text: '¿Cómo reacciona la institución ante cambios regulatorios importantes?',
            options: ['Nos enteramos tarde y actuamos de forma reactiva cuando el regulador ya presiona',
                      'Seguimos los cambios, pero sin procesos formales de implementación',
                      'Existe un proceso de seguimiento regulatorio con plan de implementación',
                      'El Consejo lidera proactivamente la agenda regulatoria con recursos asignados preventivamente'] },
        ],
        // Dim 1 – Digital
        [
          { text: '¿Qué puede hacer un socio desde su celular con la institución hoy?',
            options: ['Nada — toda la operación requiere presencia física en sucursal',
                      'Consultar saldos y movimientos, poco más',
                      'Transacciones, pagos y algunos productos desde la app',
                      'Solicitar crédito, abrir productos y operar completamente sin ir a sucursal'] },
          { text: '¿Cómo describirías el sistema core banking de la institución?',
            options: ['Sistema antiguo, difícil de modificar y con poca integración entre módulos',
                      'Funciona, pero cada cambio requiere meses y alto costo de desarrollo',
                      'Sistema moderno con integraciones básicas y algo de flexibilidad',
                      'Arquitectura abierta con APIs, integración en tiempo real y capacidad de escalar'] },
        ],
        // Dim 2 – Regulatorio
        [
          { text: '¿Cómo gestiona la institución la prevención de lavado de dinero (AML/CFT)?',
            options: ['Sin sistema — los controles son manuales o prácticamente inexistentes',
                      'Listas básicas de control, pero sin monitoreo transaccional automatizado',
                      'Sistema AML implementado con alertas y revisiones periódicas',
                      'Motor AML automatizado con monitoreo en tiempo real y auditorías regulares'] },
          { text: '¿En qué etapa está la adopción de NIIF 9 (pérdida crediticia esperada)?',
            options: ['No hemos iniciado — operamos con provisiones tradicionales sin modelo cuantitativo',
                      'Estamos en diagnóstico o planificación, sin implementación activa',
                      'Implementación parcial en algunas carteras o productos',
                      'NIIF 9 completamente implementada con modelos cuantitativos operando'] },
        ],
        // Dim 3 – Cartera
        [
          { text: '¿Cuál es el índice de morosidad real de la institución (incluyendo reestructurada y castigada)?',
            options: ['Superior al 10% — zona de alerta crítica que amenaza la viabilidad',
                      'Entre 5% y 10% — nivel de alerta que requiere atención inmediata',
                      'Entre 2% y 5% — aceptable con monitoreo activo',
                      'Menos del 2% — óptimo con gestión preventiva de riesgo'] },
          { text: '¿Cómo se toma la decisión de aprobar o rechazar un crédito?',
            options: ['Criterio del oficial, sin modelo ni reglas formales estandarizadas',
                      'Hay criterios básicos definidos pero sin herramienta de scoring cuantitativo',
                      'Usamos un scoring básico con variables cuantitativas e historial del socio',
                      'Modelo robusto con scoring, análisis de concentración y alertas tempranas'] },
        ],
        // Dim 4 – Talento
        [
          { text: '¿Qué tan difícil es contratar y retener especialistas en TI, riesgo o cumplimiento frente a bancos y fintechs?',
            options: ['Muy difícil — perdemos constantemente candidatos y empleados clave por salarios',
                      'Logramos cubrir posiciones, pero con alta rotación en roles especializados',
                      'Somos competitivos con un esquema mixto de compensación y beneficios cooperativos',
                      'Nuestra propuesta de valor atrae y retiene talento especializado con baja rotación'] },
          { text: '¿Cómo se capacita digitalmente al equipo de la institución?',
            options: ['No hay programa — cada quien aprende solo o directamente sobre la marcha',
                      'Capacitaciones esporádicas sin plan ni seguimiento de competencias',
                      'Plan anual de capacitación con módulos digitales definidos y evaluación',
                      'Programa continuo de upskilling alineado a la estrategia de transformación'] },
        ],
        // Dim 5 – Socios jóvenes
        [
          { text: '¿Qué proporción de tu base de socios tiene menos de 35 años?',
            options: ['Menos del 15% — la base se está envejeciendo sin captación joven activa',
                      'Entre 15% y 25% — captación joven limitada y sin estrategia definida',
                      'Entre 25% y 40% — presencia relevante con algunas iniciativas de captación',
                      'Más del 40% — estrategia activa con productos y canales diferenciados para jóvenes'] },
          { text: '¿Cómo se comparan tus productos de ahorro y crédito frente a Nubank, Ualá o Mercado Pago?',
            options: ['Somos claramente inferiores en tasas, acceso digital y experiencia de usuario',
                      'En tasas somos competitivos, pero la experiencia digital es notoriamente inferior',
                      'Somos competitivos con mejoras digitales actualmente en proceso',
                      'Ofrecemos una propuesta diferenciada que combina impacto social y tecnología de punta'] },
        ],
        // Dim 6 – Estrategia
        [
          { text: '¿La institución tiene un plan estratégico formal con KPIs medibles y seguimiento real?',
            options: ['No existe plan estratégico — la gestión es operativa y sin visión de largo plazo',
                      'Hay un documento de plan, pero sin KPIs ni seguimiento estructurado',
                      'Plan con KPIs y revisión anual ante el Consejo de Administración',
                      'Plan plurianual con OKRs, tablero de control y revisión trimestral ante el Consejo'] },
          { text: '¿Cómo se decide dónde invertir el presupuesto de tecnología e innovación?',
            options: ['Por inercia — similar al año anterior, sin análisis estratégico',
                      'Hay proyectos tecnológicos aprobados, pero sin criterio claro de priorización',
                      'La mayoría del presupuesto de inversión está alineado a prioridades del plan',
                      'Proceso formal de priorización con ROI esperado y rendición de cuentas al Consejo'] },
        ],
      ],

      BENCHMARK: {
        pequena: [20, 18, 22, 28, 15, 20, 18],
        mediana: [38, 35, 42, 40, 32, 35, 38],
        grande:  [52, 50, 58, 48, 46, 42, 54],
      },

      LEVELS:       ['Riesgo Crítico', 'En Proceso', 'Consolidado', 'Referente del Sector'],
      LEVEL_RANGES: ['0 – 30',        '30 – 55',    '55 – 75',     '75 – 100'],
      LEVEL_DESC:   ['Reactivo, sin procesos formales en áreas clave',
                     'Algunos procesos iniciados pero fragmentados',
                     'Estructurado y proactivo en la mayoría de dimensiones',
                     'Integrado, data-driven, referente para el sector'],
      LEVEL_COLORS: ['#b03030', '#b07020', '#2a6020', '#1D9E75'],
      LEVEL_BG:     ['#faeaea', '#faf0dc', '#eaf3de', '#e8f5ee'],
      LEVEL_TEXT:   ['#b03030', '#b07020', '#2a6020', '#0F6E56'],

      INSIGHTS: [
        'La institución enfrenta vulnerabilidades sistémicas activas. Las instituciones con este perfil son las que han sido intervenidas o liquidadas en los últimos 24 meses en LATAM. La acción en gobernanza, cumplimiento y cartera no es opcional.',
        'Existen bases operativas pero brechas estructurales en varias dimensiones. Las fintechs ya están capturando a tus socios potenciales. Las instituciones que no transformen en los próximos 2–3 años serán absorbidas o liquidadas.',
        'Tu institución está por encima de la media del sector. El siguiente nivel requiere integrar sistemas, digitalizar el talento y construir la propuesta digital que retenga a las nuevas generaciones de socios.',
        'Eres un referente del sector en madurez institucional. Tus oportunidades están en IA aplicada a riesgo crediticio, Open Finance y escalar sin incrementar costos proporcionales.',
      ],

      ROADMAP: [
        { t: 'Sistema de Gobernanza Profesional',
          r: 'Evaluación de competencias directivas, programa de formación para consejeros y protocolo de sucesión para Consejo y Gerencia General.',
          chips: ['Evaluación 360° de Consejo', 'Formación riesgo y TI', 'Protocolo de sucesión', 'Dashboard regulatorio'] },
        { t: 'Plataforma de Banca Digital Cooperativa',
          r: 'App para socios con onboarding digital, solicitud de crédito en línea y preparación para Open Finance.',
          chips: ['App móvil nativa', 'Onboarding sin papel', 'APIs Open Finance', 'Crédito digital'] },
        { t: 'Motor AML/CFT + NIIF 9',
          r: 'Sistema automatizado de prevención de lavado de dinero y modelos cuantitativos de pérdida crediticia esperada.',
          chips: ['Motor AML en tiempo real', 'Modelos PCE/NIIF 9', 'Reportería regulatoria', 'Alertas automáticas'] },
        { t: 'Plataforma de Riesgo Crediticio',
          r: 'Scoring cuantitativo, tablero de cartera con morosidad ajustada y alertas tempranas de deterioro.',
          chips: ['Scoring cuantitativo', 'Morosidad ajustada', 'Alertas de deterioro', 'Análisis concentración'] },
        { t: 'Gestión Estratégica de Talento',
          r: 'LMS con capacitación digital, matriz de competencias por rol y planes de sucesión para posiciones críticas.',
          chips: ['LMS cooperativo', 'Matriz de competencias', 'Plan de sucesión', 'Evaluación de desempeño'] },
        { t: 'Estrategia de Captación Generacional',
          r: 'Propuesta de valor digital para socios menores de 35 años con app, productos competitivos y estrategia Phygital.',
          chips: ['App socios jóvenes', 'Estrategia Phygital', 'Productos digitales', 'CRM de socios'] },
        { t: 'PMO de Transformación Digital',
          r: 'Oficina de gestión de proyectos con OKRs institucionales, tablero para el Consejo y gobierno de TI.',
          chips: ['OKRs institucionales', 'Hoja de ruta plurianual', 'Gobierno de TI', 'Tablero directivo'] },
      ],

      PHASES: ['Prioridad 1 · Urgente', 'Prioridad 2 · Crítico', 'Prioridad 3 · Estratégico'],

      thanksItems: [
        'Reporte detallado en las 7 dimensiones de madurez institucional',
        'Benchmarking vs instituciones de tu segmento en el sector',
        'Hoja de ruta con estimados de inversión y ROI esperado',
        'Sesión gratuita de 30 min con especialista Sendoagil en transformación cooperativa',
      ],
    }
  },

  computed: {
    orderedDims() {
      const all = [0, 1, 2, 3, 4, 5, 6]
      const selected = this.selectedPains.slice().sort((a, b) => a - b)
      const rest = all.filter(i => !selected.includes(i))
      return [...selected, ...rest]
    },

    activeDimIndex() {
      return this.currentScreen === 'questions' ? this.orderedDims[this.currentDimStep] : null
    },

    activeDim() {
      return this.activeDimIndex !== null ? this.DIMENSIONS[this.activeDimIndex] : null
    },

    activeDimQuestions() {
      return this.activeDimIndex !== null ? this.DIM_QUESTIONS[this.activeDimIndex] : []
    },

    isSelectedPain() {
      return this.activeDimIndex !== null && this.selectedPains.includes(this.activeDimIndex)
    },

    isLastDim() {
      return this.currentDimStep === 6 && this.currentQuestionInDim === 1
    },

    currentQuestion() {
      if (this.activeDimIndex === null) return null
      return this.DIM_QUESTIONS[this.activeDimIndex][this.currentQuestionInDim] || null
    },

    currentQuestionNumber() {
      return this.currentDimStep * 2 + this.currentQuestionInDim + 1
    },

    nextLabel() {
      return 'Siguiente →'
    },

    questionKey() {
      return `${this.currentDimStep}_${this.currentQuestionInDim}`
    },

    answeredCount() {
      return Object.keys(this.answers).length
    },

    allCurrentAnswered() {
      if (this.currentScreen !== 'questions') return false
      return this.getAnswer(this.currentDimStep, this.currentQuestionInDim) !== undefined
    },

    dimensionScores() {
      return this.orderedDims.map((dimIdx, step) => {
        const q0 = this.getAnswer(step, 0)
        const q1 = this.getAnswer(step, 1)
        const pts = (q0 !== undefined ? q0 : 0) + (q1 !== undefined ? q1 : 0)
        return Math.round(pts / 6 * 100)
      })
    },

    scoreByDim() {
      const result = {}
      this.orderedDims.forEach((dimIdx, step) => {
        result[dimIdx] = this.dimensionScores[step]
      })
      return result
    },

    overallScore() {
      const answered = Object.keys(this.answers)
      if (!answered.length) return 0
      return Math.round(Object.values(this.scoreByDim).reduce((s, v) => s + v, 0) / 7)
    },

    level() {
      const s = this.overallScore
      return s < 30 ? 0 : s < 55 ? 1 : s < 75 ? 2 : 3
    },

    benchmarkData() {
      return this.BENCHMARK[this.segment] || this.BENCHMARK.mediana
    },

    sortedDimsByScore() {
      return [0, 1, 2, 3, 4, 5, 6]
        .map(i => ({ i, s: this.scoreByDim[i] || 0 }))
        .sort((a, b) => a.s - b.s)
    },

    unexpectedWeaknesses() {
      return [0, 1, 2, 3, 4, 5, 6].filter(i =>
        !this.selectedPains.includes(i) && (this.scoreByDim[i] || 0) <= 35
      )
    },

    segmentLabel() {
      const m = { pequena: 'Caja pequeña', mediana: 'Caja mediana', grande: 'Institución grande' }
      return m[this.segment] || 'tu segmento'
    },

    radarGeometry() {
      const cx = 150, cy = 150, R = 130, n = 7
      const angle = (i) => (i * 2 * Math.PI / n) - Math.PI / 2
      const ptStr = (i, dist) => {
        const a = angle(i)
        return (cx + dist * Math.cos(a)).toFixed(1) + ',' + (cy + dist * Math.sin(a)).toFixed(1)
      }
      const dims = [0, 1, 2, 3, 4, 5, 6]

      const gridPolygons = [25, 50, 75, 100].map(pct =>
        dims.map(i => ptStr(i, (pct / 100) * R)).join(' ')
      )

      const gridLabels = [25, 50, 75].map(pct => ({
        x: cx + 4,
        y: cy - (pct / 100) * R,
        text: pct,
      }))

      const axisLines = dims.map(i => ({
        x2: (cx + R * Math.cos(angle(i))).toFixed(1),
        y2: (cy + R * Math.sin(angle(i))).toFixed(1),
      }))

      const labelDist = R + 44
      const labelPos = dims.map(i => {
        const a = angle(i)
        const x = cx + labelDist * Math.cos(a)
        const y = cy + labelDist * Math.sin(a)
        const anchor = Math.cos(a) > 0.15 ? 'start' : (Math.cos(a) < -0.15 ? 'end' : 'middle')
        return {
          x: x.toFixed(1),
          y: y.toFixed(1),
          anchor,
          label: this.DIMENSIONS[i].s,
          color: this.DIMENSIONS[i].c,
          score: this.scoreByDim[i] || 0,
        }
      })

      const scorePoints = dims.map(i => {
        const s = this.scoreByDim[i] || 0
        const d = (s / 100) * R
        const a = angle(i)
        return {
          x: (cx + d * Math.cos(a)).toFixed(1),
          y: (cy + d * Math.sin(a)).toFixed(1),
          color: this.DIMENSIONS[i].c,
        }
      })

      const scorePolygon = scorePoints.map(p => p.x + ',' + p.y).join(' ')

      const benchPolygon = dims.map(i => ptStr(i, (this.benchmarkData[i] / 100) * R)).join(' ')

      return { gridPolygons, gridLabels, axisLines, labelPos, scorePoints, scorePolygon, benchPolygon, cx, cy }
    },

    modalSubtitle() {
      const map = {
        welcome:     'Sector Cooperativo LATAM',
        institution: 'Paso 1 · Configura tu diagnóstico',
        questions:   'Pregunta ' + (this.currentDimStep * 2 + this.currentQuestionInDim + 1) + ' de 14',
        lead:        'Recibe tu reporte completo',
        thanks:      '¡Diagnóstico completado!',
      }
      return map[this.currentScreen] || ''
    },
  },

  watch: {
    showModal(val) {
      if (val) document.body.style.overflow = 'hidden'
      else if (!this.showResultsDashboard) document.body.style.overflow = ''
    },
    showResultsDashboard(val) {
      if (val) document.body.style.overflow = 'hidden'
      else if (!this.showModal) document.body.style.overflow = ''
    },
  },

  destroyed() {
    document.body.style.overflow = ''
  },

  methods: {
    checkPassword() {
      if (this.gatePassword === 'Hola2026$$') {
        sessionStorage.setItem('diag_auth', '1')
        this.authenticated = true
        this.gateError = false
      } else {
        this.gateError = true
        this.gatePassword = ''
        this.$nextTick(() => { if (this.$refs.gateInput) this.$refs.gateInput.focus() })
      }
    },

    openModal() {
      this.currentScreen = 'welcome'
      this.showModal = true
    },

    closeModal() {
      this.showModal = false
    },

    togglePain(i) {
      const idx = this.selectedPains.indexOf(i)
      if (idx >= 0) this.selectedPains.splice(idx, 1)
      else this.selectedPains.push(i)
    },

    getAnswer(step, localIdx) {
      return this.answers[`${step}_${localIdx}`]
    },

    setAnswer(step, localIdx, value) {
      this.$set(this.answers, `${step}_${localIdx}`, value)
      // Auto-avance: espera 480ms tras seleccionar para mostrar el highlight y luego avanza
      this.autoAdvancing = true
      setTimeout(() => {
        this.autoAdvancing = false
        this.nextDim()
      }, 480)
    },

    globalQuestionIndex(localIdx) {
      return this.currentDimStep * 2 + localIdx + 1
    },

    scoreLevel(s) {
      if (s < 30) return { label: 'Inicial — Riesgo crítico',      short: 'Riesgo crítico', color: '#b03030' }
      if (s < 55) return { label: 'En Proceso — Acción requerida', short: 'En proceso',      color: '#b07020' }
      if (s < 75) return { label: 'Consolidado — Buen avance',     short: 'Consolidado',     color: '#2a6020' }
      return              { label: 'Referente del sector',          short: 'Referente',       color: '#1D9E75' }
    },

    go(screen) {
      this.currentScreen = screen
      this.$nextTick(() => {
        if (this.$refs.modalBody) this.$refs.modalBody.scrollTop = 0
      })
    },

    startQuestions() {
      this.currentDimStep = 0
      this.currentQuestionInDim = 0
      this.go('questions')
    },

    nextDim() {
      this.transitionDir = 'next'
      if (this.currentQuestionInDim === 0) {
        this.currentQuestionInDim = 1
        this.$nextTick(() => { if (this.$refs.modalBody) this.$refs.modalBody.scrollTop = 0 })
      } else if (this.currentDimStep === 6) {
        // Última pregunta → abrir dashboard de resultados
        this.showModal = false
        this.$nextTick(() => { this.showResultsDashboard = true })
      } else {
        this.currentDimStep++
        this.currentQuestionInDim = 0
        this.$nextTick(() => { if (this.$refs.modalBody) this.$refs.modalBody.scrollTop = 0 })
      }
    },

    prevDim() {
      this.transitionDir = 'prev'
      if (this.currentQuestionInDim === 1) {
        this.currentQuestionInDim = 0
        this.$nextTick(() => { if (this.$refs.modalBody) this.$refs.modalBody.scrollTop = 0 })
      } else if (this.currentDimStep === 0) {
        this.go('institution')
      } else {
        this.currentDimStep--
        this.currentQuestionInDim = 1
        this.$nextTick(() => { if (this.$refs.modalBody) this.$refs.modalBody.scrollTop = 0 })
      }
    },

    goToLead() {
      this.showResultsDashboard = false
      this.currentScreen = 'lead'
      this.$nextTick(() => { this.showModal = true })
    },

    closeResultsDashboard() {
      this.showResultsDashboard = false
    },

    goBackToResults() {
      this.showModal = false
      this.$nextTick(() => { this.showResultsDashboard = true })
    },

    scrollTo(selector) {
      const el = document.querySelector(selector)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
  },

  metaInfo: {
    title: 'Diagnóstico Digital · Cajas y Cooperativas | Sendoagil',
    meta: [{ name: 'description', content: 'Evalúa la madurez institucional de tu caja o cooperativa en 14 preguntas. Diagnóstico gratuito basado en el Marco BID Lab 2025 y datos reales del sector cooperativo LATAM.' }],
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variabls.scss';

$gold:   #94692a;
$goldlt: #9f855a;
$dark:   #141514;
$dark2:  #2d2d2f;
$light:  #f3f3f2;
$muted:  #888880;
$border: #e8e5e0;

.diagnostico-wrap { padding-top: 80px; }

// ── Hero ──────────────────────────────────────────────────────────────────
.diag-hero {
  background: $dark;
  min-height: 90vh;
  display: flex;
  align-items: center;
  padding: 80px 0;
  position: relative;
  overflow: hidden;

  &__bg {
    position: absolute; inset: 0; pointer-events: none;
    background: radial-gradient(ellipse 60% 70% at 80% 50%, rgba(148,105,42,.12) 0%, transparent 70%),
                radial-gradient(ellipse 40% 40% at 15% 80%, rgba(20,21,20,.8) 0%, transparent 60%);
  }
  &__grid {
    position: absolute; inset: 0; pointer-events: none; opacity: .03;
    background-image: linear-gradient($gold 1px, transparent 1px), linear-gradient(90deg, $gold 1px, transparent 1px);
    background-size: 60px 60px;
  }
  &__inner {
    display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center;
    position: relative; z-index: 1;
  }
  &__content h1 {
    font-size: 42px; font-weight: 800; color: #fff; line-height: 1.1; margin-bottom: 1.2rem;
    em { font-style: normal; color: $gold; }
  }
  &__sub { font-size: 15px; color: #aaa; line-height: 1.75; margin-bottom: 2rem; max-width: 460px; }
  &__btns { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 2.5rem; }
  &__stats {
    display: flex; gap: 2rem; padding-top: 2rem;
    border-top: 1px solid rgba(255,255,255,.1);
  }
  &__visual { display: flex; justify-content: center; }
}

.diag-stat {
  &__n { display: block; font-size: 26px; font-weight: 800; color: $gold; }
  &__l { display: block; font-size: 12px; color: $muted; }
}

.diag-btn-hero {
  display: inline-flex; align-items: center; padding: 13px 28px; border-radius: 4px;
  font-size: 14px; font-weight: 700; cursor: pointer; border: none; font-family: inherit;
  text-decoration: none; transition: all .2s; letter-spacing: .03em;
  &--gold    { background: $gold; color: #fff; &:hover { background: $goldlt; } }
  &--outline { background: transparent; color: #fff; border: 1px solid #555; &:hover { border-color: $gold; color: $gold; } }
}

// ── Preview card ──────────────────────────────────────────────────────────
.diag-preview-card {
  background: #1e1e1e; border: 1px solid #2d2d2d; border-radius: 12px;
  padding: 1.6rem; width: 100%; max-width: 340px;

  .dpc-header { display: flex; align-items: center; gap: 10px; margin-bottom: 1rem; padding-bottom: 1rem; border-bottom: 1px solid #2d2d2d; }
  .dpc-icon { width: 36px; height: 36px; background: rgba($gold,.15); border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .dpc-title { font-size: 12px; font-weight: 700; color: #fff; }
  .dpc-sub   { font-size: 10px; color: $muted; }

  .dpc-dim { margin-bottom: 6px;
    .dpc-dim-row { display: flex; justify-content: space-between; font-size: 10px; color: #aaa; margin-bottom: 2px; }
    .dpc-bar { height: 3px; background: #2d2d2d; border-radius: 2px;
      div { height: 100%; border-radius: 2px; } }
  }

  .dpc-footer { display: flex; align-items: center; justify-content: space-between; margin-top: 1rem; padding-top: 1rem; border-top: 1px solid #2d2d2d; }
  .dpc-score { font-size: 36px; font-weight: 800; color: $gold; small { font-size: 14px; } }
  .dpc-level { font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 12px; }
}

// ── Context section ────────────────────────────────────────────────────────
.diag-context {
  background: $light; padding: 80px 0;
  &__grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center; }
  &__text p { font-size: 14px; color: #555; line-height: 1.75; }
  &__stats { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
}

.diag-cstat {
  background: #fff; border: 1px solid $border; border-radius: 10px; padding: 1.2rem;
  &__n { font-size: 30px; font-weight: 800; line-height: 1; margin-bottom: 4px; }
  &__l { font-size: 12px; color: #666; line-height: 1.4; }
}

.diag-tag { display: inline-block; font-size: 11px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; color: $gold; margin-bottom: 10px; }

.diag-section-h { font-size: 32px; font-weight: 800; color: $dark; line-height: 1.1; margin-bottom: 1rem; em { font-style: normal; color: $gold; } }

.diag-section-sub { font-size: 14px; color: #666; line-height: 1.7; max-width: 540px; }

// ── MODAL OVERLAY ─────────────────────────────────────────────────────────
.diag-overlay {
  position: fixed; inset: 0; z-index: 10000;
  background: rgba(10, 9, 8, 0.88);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  backdrop-filter: blur(4px);
}

.diag-modal {
  background: #fff;
  border-radius: 18px;
  width: 100%; max-width: 700px;
  max-height: 92vh;
  display: flex; flex-direction: column;
  overflow: hidden;
  box-shadow: 0 32px 80px rgba(0,0,0,.55), 0 0 0 1px rgba(255,255,255,.06);
  position: relative;
}

// ── Modal Header ──────────────────────────────────────────────────────────
.diag-mhd {
  background: $dark;
  padding: 14px 20px;
  display: flex; align-items: center; gap: 14px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(255,255,255,.06);
  min-height: 68px;

  &__brand {
    display: flex; align-items: center; gap: 10px; flex-shrink: 0;
  }
  &__icon {
    flex-shrink: 0; opacity: .9;
  }
  &__name {
    display: block; font-size: 12px; font-weight: 700; color: #fff; letter-spacing: .04em;
    white-space: nowrap;
  }
  &__sub {
    display: block; font-size: 10px; color: rgba(255,255,255,.45); margin-top: 1px;
    white-space: nowrap;
  }
  &__steps {
    flex: 1; display: flex; align-items: flex-start; justify-content: center;
    overflow: hidden;
  }
  &__close {
    flex-shrink: 0; width: 34px; height: 34px; border-radius: 50%; border: none;
    background: rgba(255,255,255,.08); color: rgba(255,255,255,.7); cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: background .2s, color .2s;
    &:hover { background: rgba(255,255,255,.16); color: #fff; }
  }
}

// ── Step dots ─────────────────────────────────────────────────────────────
.diag-step {
  display: flex; flex-direction: column; align-items: center; flex-shrink: 0;

  &__dot {
    width: 26px; height: 26px; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 10px; font-weight: 700; color: #555;
    background: #252523; border: 1.5px solid #3a3a38;
    transition: all .3s; position: relative; z-index: 1;
  }
  &__lbl {
    font-size: 7.5px; color: rgba(255,255,255,.3); margin-top: 4px;
    letter-spacing: .05em; text-transform: uppercase; white-space: nowrap;
    transition: color .3s;
  }
  &__pain {
    font-size: 7px; color: $gold; margin-top: 1px; line-height: 1;
  }

  &--done &__dot {
    background: $gold; border-color: $gold; color: #fff;
  }
  &--done &__lbl { color: rgba(255,255,255,.5); }

  &--active &__dot {
    background: $gold; border-color: $gold; color: #fff;
    box-shadow: 0 0 0 4px rgba($gold, .25), 0 0 12px rgba($gold, .4);
    animation: step-glow 2s ease-in-out infinite;
  }
  &--active &__lbl { color: rgba(255,255,255,.8); }
}

.diag-step-line {
  height: 1.5px; flex: 1; min-width: 8px; max-width: 32px;
  background: #3a3a38; margin-top: 12px; transition: background .3s;
  &--done { background: $gold; }
}

@keyframes step-glow {
  0%, 100% { box-shadow: 0 0 0 4px rgba($gold,.25), 0 0 12px rgba($gold,.3); }
  50%       { box-shadow: 0 0 0 6px rgba($gold,.35), 0 0 20px rgba($gold,.5); }
}

// ── Modal Body ────────────────────────────────────────────────────────────
.diag-modal__body {
  flex: 1; overflow-y: auto; padding: 28px;
  scrollbar-width: thin;
  scrollbar-color: $border transparent;
  &::-webkit-scrollbar { width: 5px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: $border; border-radius: 3px; }
}

// ── Progress bar ──────────────────────────────────────────────────────────
.diag-prog {
  margin-bottom: 1.4rem;
  &__top { display: flex; justify-content: space-between; margin-bottom: 6px; }
  &__label { font-size: 12px; color: $muted; }
  &__num { font-size: 12px; font-weight: 600; color: $dark; }
  &__track { height: 3px; background: #e8e5e0; border-radius: 2px; }
  &__fill { height: 100%; background: linear-gradient(90deg, $gold, $goldlt); border-radius: 2px; transition: width .4s ease; }
}

// ── Card ──────────────────────────────────────────────────────────────────
.diag-card {
  h3 { font-size: 21px; font-weight: 700; color: $dark; margin-bottom: 6px; }
  &--center { text-align: center; h3 { margin-bottom: 8px; } }
}
.diag-card__sub { font-size: 14px; color: #777; line-height: 1.65; margin-bottom: 1.4rem; }
.diag-hint { font-size: 11px; color: $muted; text-align: center; margin-top: 8px; }

// ── Welcome model ─────────────────────────────────────────────────────────
.diag-welcome-model {
  background: $light; border-radius: 10px; padding: 1.2rem; margin-bottom: 1.5rem;
}
.diag-level-row {
  display: grid; grid-template-columns: 10px 110px 70px 1fr; gap: 10px; align-items: center;
  padding: 6px 0; border-bottom: 1px solid $border;
  &:last-child { border-bottom: none; }
}
.diag-level-dot { width: 8px; height: 8px; border-radius: 50%; }
.diag-level-name { font-size: 12px; font-weight: 700; }
.diag-level-range { font-size: 11px; color: $muted; }
.diag-level-desc { font-size: 11px; color: #666; }

// ── Form ──────────────────────────────────────────────────────────────────
.diag-label {
  display: block; font-size: 11px; font-weight: 600; color: $muted;
  letter-spacing: .06em; text-transform: uppercase; margin-bottom: 6px;
  &__hint { font-size: 10px; color: $muted; text-transform: none; letter-spacing: 0; margin-left: 6px; font-weight: 400; }
}
.diag-input {
  width: 100%; height: 44px; border: 1.5px solid $border; border-radius: 6px; padding: 0 14px;
  font-size: 14px; color: $dark; background: #fff; margin-bottom: 1.2rem; outline: none;
  transition: border-color .2s; font-family: inherit;
  &:focus { border-color: $gold; }
}
.diag-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.diag-pills  { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 1.2rem; }
.diag-pill {
  padding: 6px 16px; border: 1.5px solid $border; border-radius: 20px; font-size: 12px;
  cursor: pointer; color: $muted; background: #fff; transition: all .2s; font-weight: 500;
  &--on { border-color: $gold; color: $dark; background: rgba($gold,.08); }
}

// ── Pain selection grid ───────────────────────────────────────────────────
.diag-pain-grid {
  display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; margin-bottom: 1.4rem;
}
.diag-pain-card {
  display: flex; align-items: center; gap: 10px; padding: 10px 14px;
  border: 1.5px solid $border; border-radius: 8px; cursor: pointer; font-size: 13px;
  color: #555; background: #fff; transition: all .2s; position: relative;
  &:hover { border-color: rgba($gold,.4); background: rgba($gold,.03); }
  &--on { border-color: $gold; color: $dark; background: rgba($gold,.06); }
}
.diag-pain-icon { flex-shrink: 0; color: $gold; opacity: .7; .diag-pain-card--on & { opacity: 1; } }
.diag-pain-check {
  position: absolute; top: -5px; right: -5px; width: 16px; height: 16px;
  background: $gold; border-radius: 50%; display: flex; align-items: center; justify-content: center;
}

// ── Dimension header ──────────────────────────────────────────────────────
.diag-dim-header { margin-bottom: 0; }
.diag-dim-meta { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; flex-wrap: wrap; }
.diag-dim-badge {
  display: inline-flex; align-items: center; padding: 4px 12px; border-radius: 20px;
  font-size: 10px; font-weight: 700; letter-spacing: .07em; text-transform: uppercase;
}
.diag-dim-tag {
  display: inline-block; font-size: 10px; font-weight: 700; padding: 3px 10px;
  border-radius: 12px; letter-spacing: .05em; text-transform: uppercase;
  &--priority { background: rgba($gold,.15); color: $gold; }
  &--extra { background: #f0f0f0; color: $muted; }
}
.diag-dim-title {
  font-size: 20px; font-weight: 700; color: $dark; margin-bottom: 8px; line-height: 1.2;
}
.diag-dim-desc {
  font-size: 13px; color: #888; line-height: 1.7; margin-bottom: 0;
}
.diag-q-divider {
  height: 1px; background: $border; margin: 1.4rem 0;
}

// ── Questions ─────────────────────────────────────────────────────────────
.diag-qblock { margin-bottom: 1.6rem; }
.diag-qn { font-size: 10px; color: $muted; letter-spacing: .1em; text-transform: uppercase; margin-bottom: 4px; }
.diag-qt { font-size: 15px; font-weight: 500; color: $dark; margin-bottom: 10px; line-height: 1.5; }
.diag-opts { display: flex; flex-direction: column; gap: 6px; }

.diag-opt {
  display: flex; align-items: flex-start; gap: 12px; padding: 11px 14px; border: 1.5px solid $border;
  border-radius: 8px; cursor: pointer; font-size: 13px; color: $dark; background: #fff;
  text-align: left; transition: all .2s; width: 100%; font-family: inherit; line-height: 1.4;
  &:hover { border-color: rgba($gold,.4); background: rgba($gold,.04); }
  &--on   { background: rgba($gold,.08); border-color: $gold; }
}
.diag-opt-level { display: block; font-size: 9px; color: $muted; letter-spacing: .08em; text-transform: uppercase; margin-bottom: 2px; font-weight: 600; }

.diag-odot {
  width: 16px; height: 16px; border-radius: 50%; border: 2px solid $border; flex-shrink: 0;
  margin-top: 3px; transition: all .2s; position: relative;
  .diag-opt--on & { border-color: $gold; background: $gold;
    &::after { content: ''; position: absolute; inset: 3px; border-radius: 50%; background: $dark; } }
}

// ── Buttons ───────────────────────────────────────────────────────────────
.diag-btn {
  display: block; width: 100%; padding: 13px; border: none; border-radius: 6px;
  font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit;
  letter-spacing: .04em; text-transform: uppercase; transition: all .2s; margin-top: 6px;
  &--accent   { background: $gold;  color: #fff; &:hover { background: $goldlt; } }
  &--disabled { background: #e8e5e0; color: $muted; cursor: not-allowed; }
  &--back     { background: transparent; color: $muted; border: 1.5px solid $border; &:hover { border-color: #aaa; color: $dark; } }
}

// ── Results ───────────────────────────────────────────────────────────────
.diag-results-header { margin-bottom: 1.4rem; }

.diag-results-score-wrap {
  display: flex; align-items: center; gap: 1.2rem; border-radius: 12px; padding: 1.4rem 1.6rem; margin-bottom: 1rem;
}
.diag-results-score { font-size: 68px; font-weight: 800; line-height: 1; }
.diag-results-level { font-size: 17px; font-weight: 700; }
.diag-results-inst  { font-size: 13px; color: #555; margin-top: 2px; }
.diag-results-seg   { font-size: 11px; color: $muted; }

.diag-results-insight {
  border-left: 3px solid; border-radius: 0 8px 8px 0; padding: 12px 16px;
  font-size: 13px; color: #444; line-height: 1.7;
}

.diag-alert-box {
  display: flex; align-items: flex-start; gap: 10px;
  background: #faf0dc; border: 1px solid #e8c96a; border-radius: 8px;
  padding: 12px 16px; margin-bottom: 1.4rem; font-size: 13px; color: #7a5010; line-height: 1.6;
}
.diag-alert-icon { flex-shrink: 0; margin-top: 2px; }

.diag-slbl {
  font-size: 11px; font-weight: 700; letter-spacing: .12em; text-transform: uppercase;
  color: $muted; margin: 1.4rem 0 .8rem;
}

// ── Dimension score rows ──────────────────────────────────────────────────
.diag-dim-scores { display: flex; flex-direction: column; gap: 14px; }

.diag-dim-score-row {
  padding: 12px 14px; border: 1px solid $border; border-radius: 8px; transition: border-color .2s;
  &--alert { border-color: #f0c0c0; background: #fff9f9; }
}
.diag-dim-score-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; flex-wrap: wrap; gap: 6px; }
.diag-dim-score-name { display: flex; align-items: center; gap: 8px; font-weight: 600; font-size: 13px; color: $dark; }
.diag-dim-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.diag-dim-score-badges { display: flex; align-items: center; gap: 8px; }
.diag-dim-score-val { font-size: 14px; font-weight: 800; }

.diag-badge {
  font-size: 10px; font-weight: 700; padding: 2px 8px; border-radius: 10px; letter-spacing: .04em;
  &--priority { background: rgba($gold,.15); color: $gold; }
  &--alert    { background: #faf0dc; color: #b07020; }
}

.diag-bar-wrap { display: flex; align-items: center; gap: 10px; margin-bottom: 4px; }
.diag-bar-track { flex: 1; height: 7px; background: #e8e5e0; border-radius: 4px; position: relative; overflow: visible; }
.diag-bar-fill  { height: 100%; border-radius: 4px; transition: width .6s ease; }
.diag-bar-bench { position: absolute; top: -4px; width: 2px; height: 15px; background: #bbb; border-radius: 1px; }
.diag-bar-vs    { font-size: 11px; font-weight: 600; white-space: nowrap; }
.diag-maturity-label { font-size: 10px; font-weight: 600; letter-spacing: .04em; }

// ── Roadmap ───────────────────────────────────────────────────────────────
.diag-roadmap-card {
  border-left: 3px solid; border-radius: 0 8px 8px 0; padding: 14px 16px; margin-bottom: 10px;
}
.diag-roadmap-header { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.diag-roadmap-phase {
  font-size: 10px; font-weight: 700; color: #fff; padding: 3px 10px;
  border-radius: 12px; letter-spacing: .04em; text-transform: uppercase;
}
.diag-roadmap-dim {
  font-size: 10px; font-weight: 700; padding: 3px 10px;
  border-radius: 12px; letter-spacing: .04em; text-transform: uppercase;
}
.diag-roadmap-title { font-size: 13px; font-weight: 700; margin-bottom: 4px; text-transform: uppercase; letter-spacing: .03em; }
.diag-roadmap-desc  { font-size: 13px; line-height: 1.6; margin-bottom: 8px; }
.diag-roadmap-chips { display: flex; flex-wrap: wrap; gap: 4px; }

.diag-chip {
  display: inline-block; font-size: 10px; padding: 3px 9px; border-radius: 12px;
  border: 1px solid; font-weight: 600; letter-spacing: .03em;
}

.diag-result-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 1.6rem; }

// ── Lead badge ────────────────────────────────────────────────────────────
.diag-lead-badge { border-radius: 10px; padding: 14px 18px; display: flex; align-items: center; gap: 14px; margin-bottom: 1.4rem; }
.diag-lb-score   { font-size: 44px; font-weight: 800; min-width: 60px; line-height: 1; }
.diag-lb-level   { font-size: 14px; font-weight: 700; }
.diag-lb-inst    { font-size: 12px; opacity: .7; }

// ── Thanks ────────────────────────────────────────────────────────────────
.diag-thanks-icon { width: 54px; height: 54px; background: #e8f5ee; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 1.2rem; }
.diag-thanks-list { background: $light; border-radius: 8px; padding: 1.2rem; text-align: left; }
.diag-thanks-item { display: flex; gap: 10px; align-items: flex-start; margin-bottom: 8px; font-size: 13px; line-height: 1.5; }
.diag-check-dot { width: 18px; height: 18px; background: #e8f5ee; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 1px; }

// ── Slide transition entre preguntas ─────────────────────────────────────
.diag-question-wrap { will-change: transform, opacity; }

.q-slide-next-enter-active,
.q-slide-next-leave-active,
.q-slide-prev-enter-active,
.q-slide-prev-leave-active {
  transition: opacity .22s ease, transform .24s cubic-bezier(.4,0,.2,1);
}
.q-slide-next-enter  { opacity: 0; transform: translateX(28px); }
.q-slide-next-leave-to { opacity: 0; transform: translateX(-28px); }
.q-slide-prev-enter  { opacity: 0; transform: translateX(-28px); }
.q-slide-prev-leave-to { opacity: 0; transform: translateX(28px); }

// ── Navegación de preguntas ───────────────────────────────────────────────
.diag-q-nav {
  display: flex; align-items: center; gap: 10px; margin-top: 4px;
}
.diag-btn--nav { flex: 1; margin-top: 0; }
.diag-btn--back-sm {
  flex-shrink: 0; width: auto; padding: 13px 18px; margin-top: 0;
  background: transparent; color: $muted; border: 1.5px solid $border;
  border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all .2s; white-space: nowrap;
  &:hover { border-color: #aaa; color: $dark; }
}

// ── Auto-advance feedback ─────────────────────────────────────────────────
.diag-opt--advancing {
  animation: opt-advance .48s ease forwards;
}
@keyframes opt-advance {
  0%   { background: rgba($gold,.08); border-color: $gold; }
  60%  { background: rgba($gold,.22); border-color: $gold; box-shadow: 0 0 0 3px rgba($gold,.15); }
  100% { background: rgba($gold,.08); border-color: $gold; }
}

// ── Transitions overlay/modal ─────────────────────────────────────────────
.diag-fade-enter-active,
.diag-fade-leave-active { transition: opacity .25s ease; }
.diag-fade-enter,
.diag-fade-leave-to { opacity: 0; }

.diag-modal-enter-enter-active { transition: opacity .25s ease, transform .3s cubic-bezier(.34,1.56,.64,1); }
.diag-modal-enter-leave-active { transition: opacity .2s ease, transform .2s ease; }
.diag-modal-enter-enter        { opacity: 0; transform: scale(.93) translateY(16px); }
.diag-modal-enter-leave-to     { opacity: 0; transform: scale(.96) translateY(8px); }

// ── Dashboard de resultados ───────────────────────────────────────────────
.diag-dash {
  background: #fff;
  border-radius: 16px;
  width: min(1160px, 97vw);
  max-height: 95vh;
  display: flex; flex-direction: column;
  overflow: hidden;
  box-shadow: 0 40px 100px rgba(0,0,0,.65);

  &__hd {
    background: $dark; padding: 12px 22px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: space-between;
    border-bottom: 1px solid rgba(255,255,255,.06);
    &-brand { display: flex; align-items: center; gap: 12px; }
  }
  &__inst { font-size: 14px; font-weight: 700; color: #fff; }
  &__meta { font-size: 10px; color: rgba(255,255,255,.4); margin-top: 1px; }

  // Body: 3 columnas (score | radar | dims)
  &__body {
    display: grid;
    grid-template-columns: 190px 1fr 360px;
    flex: 1; overflow: hidden; min-height: 0;
  }

  // Col 1 – Score
  &__score-panel {
    background: #faf9f7; border-right: 1px solid $border;
    padding: 20px 18px; display: flex; flex-direction: column; overflow-y: auto;
  }
  &__score-num { font-size: 72px; font-weight: 800; line-height: 1; }
  &__score-lbl { font-size: 9px; color: $muted; text-transform: uppercase; letter-spacing: .09em; margin: 3px 0 8px; line-height: 1.4; }
  &__score-level { font-size: 15px; font-weight: 700; margin-bottom: 5px; }
  &__score-range { display: inline-block; font-size: 10px; font-weight: 700; padding: 2px 9px; border-radius: 12px; margin-bottom: 14px; }
  &__insight { font-size: 11px; color: #666; line-height: 1.65; border-left: 3px solid $border; padding-left: 9px; margin: 0; flex: 1; }
  &__alert { margin-top: 12px; background: #faf0dc; border: 1px solid #e8c96a; border-radius: 8px; padding: 9px 11px; font-size: 10px; color: #7a5010; line-height: 1.6; flex-shrink: 0; }

  // Col 2 – Radar
  &__radar-panel {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    padding: 12px; border-right: 1px solid $border; background: #fdfdfc;
    overflow: hidden;
  }

  // Col 3 – Leyenda dimensiones
  &__dims {
    padding: 12px 14px; overflow: hidden; display: flex; flex-direction: column;
    &-hd { margin-bottom: 8px; flex-shrink: 0; }
    &-title { font-size: 9px; font-weight: 700; letter-spacing: .12em; text-transform: uppercase; color: $muted; }
  }
  &__pain-tag { font-size: 8px; color: $gold; font-weight: 700; flex-shrink: 0; }
}

// ── Dimension 2-col card grid ─────────────────────────────────────────────
.diag-dims-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  flex: 1; align-content: start;
}
.diag-dim-card {
  background: #faf9f7; border: 1px solid #ece9e3; border-radius: 7px;
  padding: 7px 9px;
  &__top {
    display: flex; align-items: center; gap: 5px; margin-bottom: 4px;
  }
  &__dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
  &__name { font-size: 10px; font-weight: 600; color: $dark; flex: 1; line-height: 1.2; }
  &__score {
    font-size: 14px; font-weight: 800; flex-shrink: 0; line-height: 1;
    small { font-size: 8px; font-weight: 400; color: $muted; }
  }
  &__bot {
    display: flex; align-items: baseline; justify-content: space-between; gap: 4px;
  }
  &__vs { font-size: 9px; font-weight: 700; }
  &__mat { font-size: 8px; font-weight: 600; letter-spacing: .02em; text-align: right; }
}

.diag-dash {

  // Roadmap
  &__roadmap {
    border-top: 1px solid $border; padding: 12px 20px; flex-shrink: 0; background: $light;
  }
  &__rm-hd { font-size: 9px; font-weight: 700; letter-spacing: .12em; text-transform: uppercase; color: $muted; margin-bottom: 9px; }
  &__rm-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
  &__rm-card {
    background: #fff; border: 1px solid $border; border-top: 3px solid;
    border-radius: 0 0 8px 8px; padding: 10px;
  }
  &__rm-phase { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; margin-bottom: 4px; }
  &__rm-dim { display: inline-block; font-size: 8px; font-weight: 700; padding: 2px 7px; border-radius: 10px; letter-spacing: .06em; text-transform: uppercase; margin-bottom: 5px; }
  &__rm-title { font-size: 11px; font-weight: 700; color: $dark; text-transform: uppercase; letter-spacing: .02em; margin-bottom: 3px; }
  &__rm-desc  { font-size: 10px; color: #666; line-height: 1.5; margin-bottom: 7px; }
  &__rm-chips { display: flex; flex-wrap: wrap; gap: 3px; }

  // Acciones
  &__actions {
    padding: 10px 20px; display: flex; align-items: center; gap: 12px;
    border-top: 1px solid $border; flex-shrink: 0;
    .diag-btn { margin-top: 0; }
  }
  &__actions-hint { font-size: 10px; color: $muted; flex: 1; }
}

// ── Gantt roadmap ─────────────────────────────────────────────────────────
.diag-gantt {
  position: relative;

  &__ruler {
    position: relative; height: 22px; margin-bottom: 6px;
    border-bottom: 1px solid $border;
  }
  &__tick {
    position: absolute; bottom: 4px; font-size: 8px; color: $muted; font-weight: 600;
    transform: translateX(-50%);
    &:first-child { transform: translateX(0); }
    &:last-child  { transform: translateX(-100%); }
  }
  &__grid-line {
    position: absolute; top: 0; bottom: -200px; width: 1px;
    background: $border; pointer-events: none; z-index: 0;
  }

  &__row { margin-bottom: 10px; position: relative; }

  &__item {
    display: flex; flex-direction: column; gap: 4px;
    position: relative; z-index: 1;
  }

  &__bar {
    height: 30px; border-radius: 5px; display: flex; align-items: center;
    gap: 8px; padding: 0 12px; overflow: hidden; box-shadow: 0 2px 6px rgba(0,0,0,.18);
  }
  &__p-tag {
    font-size: 9px; color: rgba(255,255,255,.75); font-weight: 800;
    letter-spacing: .06em; flex-shrink: 0;
  }
  &__d-tag {
    font-size: 8px; font-weight: 700; padding: 2px 8px; border-radius: 8px;
    letter-spacing: .05em; text-transform: uppercase; flex-shrink: 0;
  }
  &__bar-title {
    font-size: 10px; font-weight: 700; color: rgba(255,255,255,.95);
    text-transform: uppercase; letter-spacing: .03em;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }

  &__chips {
    display: flex; flex-wrap: wrap; gap: 3px; padding-left: 4px;
  }
}

// ── Radar chart ───────────────────────────────────────────────────────────
.diag-radar {
  width: 100%; max-width: 340px; height: auto;
}
.diag-radar-legend {
  display: flex; gap: 16px; margin-top: 6px;
  &__item {
    font-size: 9px; color: $muted; display: flex; align-items: center; gap: 5px;
    &::before { content: ''; display: inline-block; width: 20px; height: 2px; border-radius: 1px; }
    &--score::before { background: #94692a; }
    &--bench::before { background: #c8b88a; border: none; border-top: 1.5px dashed #c8b88a; height: 0; }
  }
}

// ── WhatsApp ──────────────────────────────────────────────────────────────
.whatsapp-container {
  position: fixed; bottom: 25px; right: 25px; z-index: 9999;
}
.whatsapp-btn {
  width: 70px; height: 70px; background: #25d366; border-radius: 50%;
  display: flex; justify-content: center; align-items: center;
  box-shadow: 0 6px 20px rgba(0,0,0,.3); cursor: pointer; transition: transform .25s ease;
  animation: wa-pulse 2s infinite;
  img { width: 38px; height: 38px; }
  &:hover { transform: scale(1.1); }
}
@keyframes wa-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(37,211,102,.4); }
  70%  { box-shadow: 0 0 0 18px rgba(37,211,102,0); }
  100% { box-shadow: 0 0 0 0 rgba(37,211,102,0); }
}

// ── Password Gate ─────────────────────────────────────────────────────────
.diag-gate {
  min-height: 100vh; display: flex; align-items: center; justify-content: center;
  background: $dark; padding: 40px 20px;
}
.diag-gate__box {
  background: #fff; border-radius: 16px; padding: 48px 40px;
  width: 100%; max-width: 400px; text-align: center;
  box-shadow: 0 20px 60px rgba(0,0,0,.4);
}
.diag-gate__logo {
  margin-bottom: 24px;
  img { height: 36px; object-fit: contain; }
}
.diag-gate__title {
  font-size: 22px; font-weight: 800; color: $dark; margin-bottom: 8px;
}
.diag-gate__sub {
  font-size: 13px; color: $muted; margin-bottom: 28px; line-height: 1.5;
}
.diag-gate__form { display: flex; flex-direction: column; gap: 10px; }
.diag-gate__input {
  width: 100%; padding: 12px 16px; border: 1.5px solid $border; border-radius: 8px;
  font-size: 14px; outline: none; transition: border-color .2s;
  &:focus { border-color: $gold; }
  &--error { border-color: #b03030; }
}
.diag-gate__error {
  font-size: 12px; color: #b03030; margin: 0; text-align: left;
}

// ── Responsive ────────────────────────────────────────────────────────────
@media (max-width: 991px) {
  .diag-hero__inner       { grid-template-columns: 1fr; }
  .diag-hero__content h1  { font-size: 32px; }
  .diag-hero__visual      { display: none; }
  .diag-context__grid     { grid-template-columns: 1fr; }
  .diag-grid-2            { grid-template-columns: 1fr; }
  .diag-pain-grid         { grid-template-columns: 1fr; }
  .diag-dash__body        { grid-template-columns: 1fr; }
  .diag-dash__score-panel { border-right: none; border-bottom: 1px solid $border; max-height: 200px; }
  .diag-dash__rm-grid     { grid-template-columns: 1fr; }
}

@media (max-width: 575px) {
  .diag-overlay { padding: 0; align-items: flex-end; }
  .diag-modal {
    max-width: 100%; border-radius: 18px 18px 0 0; max-height: 96vh;
  }
  .diag-modal__body { padding: 20px 16px; }
  .diag-section-h { font-size: 26px; }
  .diag-level-row { grid-template-columns: 10px 1fr; grid-template-rows: auto auto;
    .diag-level-range, .diag-level-desc { display: none; } }
  .diag-mhd { padding: 12px 14px; }
  .diag-step-line { min-width: 4px; max-width: 16px; }
  .diag-step__dot { width: 22px; height: 22px; font-size: 9px; }
  .diag-step__lbl { display: none; }
  .diag-dash { border-radius: 14px 14px 0 0; max-height: 97vh; }
  .diag-dash__actions { flex-wrap: wrap; }
  .diag-dash__actions-hint { order: 3; flex-basis: 100%; }
}
</style>
